module.exports = __webpack_public_path__ + "img/13.d48e81e0.png";